module.exports = __webpack_public_path__ + "static/media/HallB.76b2d52d.jpg";